import React, { useState } from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { CollapsibleList } from 'ui-components/components/collapsible-list';
import { CollapsibleListSection } from 'ui-components/components/collapsible-list/collapsible-list-section';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { FancyStateIcon } from 'ui-components/components/fancy-state-icon';
import { Button } from 'ui-components/components/button';
import Global from '../../../store/global-selectors';

import style from './mappings-import-log.module.less';

const messages = defineMessages({
  importCompleted: {
    description: 'mappingsImportLogModal.importCompleted',
    defaultMessage: 'Import Completed!',
    id: 'LnguhH',
  },
});

export const MappingsImportLogModal = ({ modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  const intl = useIntl();
  const [expand, setExpand] = useState(true);
  const isLoading = useSelector(Global.selectOrdersImportIsLoading);
  const importLog = useSelector(Global.selectOrdersImportLog);
  const parsedImportLogErrors = (logToParse) => {
    return logToParse.split('<br>').filter((item) => (!item.includes('was created successfully') ? item.replace(/&quot;/g, '"') : null));
  };

  return (
    <Modal className={style['mappings-import-log-modal']} size='medium'>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Import Orders' description='mappingsImportLogModal.title' id='hLUMsc' />
      </ModalHeader>
      <ModalBody className={style['mappings-import-log-modal-body']}>
        {isLoading && <LoadingIndicator className={style['loading-indicator']} />}
        <p className={style['mappings-import-log-complete']}>{intl.formatMessage(messages.importCompleted)}</p>
        <CollapsibleList className={style['mappings-import-log-modal-collapsible']}>
          <CollapsibleListSection open={expand}>
            <CollapsibleListSectionHeader onClick={() => setExpand(!expand)}>
              <div className={style['error-log-header']}>
                <div className={style['error-log-header-first-section']}>
                  <div className={style['error-log-indicator-icon']}>
                    <FancyStateIcon state='error' />
                  </div>
                  <div className={style['error-log-indicator-name']}>
                    <FormattedMessage defaultMessage='Error' description='mappingsImportLogModal.error' id='fg6Ftv' />
                  </div>
                </div>
                <div className={style['error-log-header-second-section']}>
                  <div className={style['error-log-description']}>
                    <FormattedMessage
                      defaultMessage='Some of the fields could not be imported'
                      description='mappingsImportLogModal.description'
                      id='pot45h'
                    />
                  </div>
                </div>
              </div>
            </CollapsibleListSectionHeader>
            <CollapsibleListSectionContent>
              <div className={style['error-log-collapsible-content']}>
                <div className={style['error-log-collapsible-content-head']}>
                  <FormattedMessage defaultMessage='Error' description='mappingsImportLogModal.contentHead' id='SW0nIm' />
                </div>
                {parsedImportLogErrors(importLog.htmlMessage).map((error, index) => {
                  return (
                    error && (
                      <div key={index} className={style['error-log-collapsible-content-body']}>
                        {error}
                      </div>
                    )
                  );
                })}
              </div>
            </CollapsibleListSectionContent>
          </CollapsibleListSection>
        </CollapsibleList>
      </ModalBody>
      {!isLoading && (
        <ModalFooter className={style['mappings-import-log-modal-footer']}>
          <Button className={style['cancel-button-text']} onClick={closeModal} theme='tertiary'>
            <FormattedMessage defaultMessage='Close' description='mappingsImportLogModal.startImport' id='UhST7N' />
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};

MappingsImportLogModal.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
